<template>
  <div>
    <template v-for="(items, index) in form.mchShopBizTimes">
      <el-form-item :label="items.title" :prop="items.prop">
        <div class="input" v-for="(week, index) in items.week">
          <div class="week_name">
            <el-checkbox v-model="week.isOnBussiness">{{
              weekName[week.day]
            }}</el-checkbox>
            <template v-if="week.day == 0">
              <el-button class="button" size="mini" @click="dialog = true">{{
                language("shopInformation.viewPublicHoliday")
              }}</el-button>
            </template>
          </div>
          <div v-if="week.day">
            <!-- <span>{{ language("shopInformation.open") }}</span> -->
            <!-- <el-time-picker
              :disabled="!week.isOnBussiness"
              v-model="week.openTime"
              placeholder
              value-format="HH:mm:ss"
            ></el-time-picker>
            <span>{{ language("shopInformation.close") }}</span>
            <el-time-picker
              :disabled="!week.isOnBussiness || week.openTime == ''"
              v-model="week.closeTime"
              placeholder
              value-format="HH:mm:ss"
            ></el-time-picker> -->
            <!-- {{ week.time }} -->
            <el-time-picker
              is-range
              v-model="week.time"
              range-separator="-"
              :disabled="!week.isOnBussiness"
              :value-format="'HH:mm:ss'"
            >
            </el-time-picker>
          </div>
        </div>
      </el-form-item>
    </template>
    <template v-if="dialog">
      <!-- :title="公眾假期" -->
      <el-dialog
        :close-on-click-modal="false"
        :title="language('shopInformation.publicHoliday')"
        :visible.sync="dialog"
        width="90%"
        append-to-body
      >
        <holiday></holiday>
      </el-dialog>
    </template>
  </div>
</template>

<script>
import holiday from "../holiday";
export default {
  model: {
    prop: "forms",
    event: "change",
  },
  components: {
    holiday,
  },
  props: {
    formData: Object,
  },
  data() {
    return {
      value1: [new Date(2016, 9, 10, 8, 40), new Date(2016, 9, 10, 9, 40)],
      options: {
        start: "00:00",
        step: "00:05",
        end: "23:55",
      },
      weekName: [
        "Public Holiday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
      form: {
        mchShopBizTimes: [
          {
            title: "Business Hours - C.S.",
            prop: "mchShopBizTimes",
            week: [
              {
                day: 1,
                isOnBussiness: true,
                openTime: "09:00:00",
                closeTime: "18:00:00",
                time: ["09:00:00", "18:00:00"],
                type: 0,
                appId: "supnr",
              },
              {
                day: 2,
                isOnBussiness: true,
                openTime: "09:00:00",
                closeTime: "18:00:00",
                time: ["09:00:00", "18:00:00"],
                type: 0,
                appId: "supnr",
              },
              {
                day: 3,
                isOnBussiness: true,
                openTime: "09:00:00",
                closeTime: "18:00:00",
                time: ["09:00:00", "18:00:00"],
                type: 0,
                appId: "supnr",
              },
              {
                day: 4,
                isOnBussiness: true,
                openTime: "09:00:00",
                closeTime: "18:00:00",
                time: ["09:00:00", "18:00:00"],
                type: 0,
                appId: "supnr",
              },
              {
                day: 5,
                isOnBussiness: true,
                openTime: "09:00:00",
                closeTime: "18:00:00",
                time: ["09:00:00", "18:00:00"],
                type: 0,
                appId: "supnr",
              },
              {
                day: 6,
                isOnBussiness: true,
                openTime: "09:00:00",
                closeTime: "18:00:00",
                time: ["09:00:00", "18:00:00"],
                type: 0,
                appId: "supnr",
              },
              {
                day: 7,
                isOnBussiness: true,
                openTime: "09:00:00",
                closeTime: "18:00:00",
                time: ["09:00:00", "18:00:00"],
                type: 0,
                appId: "supnr",
              },
              {
                day: 0,
                isOnBussiness: true,
                openTime: "",
                closeTime: "",
                time: [],
                type: 0,
                appId: "supnr",
              },
            ],
          },
          {
            title: "Business Hours - Delivery",
            prop: "mchShopBizTimes2",
            week: [
              {
                day: 1,
                isOnBussiness: true,
                openTime: "09:00:00",
                closeTime: "18:00:00",
                time: ["09:00:00", "18:00:00"],
                type: 1,
                appId: "supnr",
              },
              {
                day: 2,
                isOnBussiness: true,
                openTime: "09:00:00",
                closeTime: "18:00:00",
                time: ["09:00:00", "18:00:00"],
                type: 1,
                appId: "supnr",
              },
              {
                day: 3,
                isOnBussiness: true,
                openTime: "09:00:00",
                closeTime: "18:00:00",
                time: ["09:00:00", "18:00:00"],
                type: 1,
                appId: "supnr",
              },
              {
                day: 4,
                isOnBussiness: true,
                openTime: "09:00:00",
                closeTime: "18:00:00",
                time: ["09:00:00", "18:00:00"],
                type: 1,
                appId: "supnr",
              },
              {
                day: 5,
                isOnBussiness: true,
                openTime: "09:00:00",
                closeTime: "18:00:00",
                time: ["09:00:00", "18:00:00"],
                type: 1,
                appId: "supnr",
              },
              {
                day: 6,
                isOnBussiness: true,
                openTime: "09:00:00",
                closeTime: "18:00:00",
                time: ["09:00:00", "18:00:00"],
                type: 1,
                appId: "supnr",
              },
              {
                day: 7,
                isOnBussiness: true,
                openTime: "09:00:00",
                closeTime: "18:00:00",
                time: ["09:00:00", "18:00:00"],
                type: 1,
                appId: "supnr",
              },
              {
                day: 0,
                isOnBussiness: true,
                openTime: "",
                closeTime: "",
                time: [],
                type: 1,
                appId: "supnr",
              },
            ],
          },
          {
            title: "Business Hours - Services",
            prop: "mchShopBizTimes3",
            week: [
              {
                day: 1,
                isOnBussiness: true,
                openTime: "09:00:00",
                closeTime: "18:00:00",
                time: ["09:00:00", "18:00:00"],
                type: 2,
                appId: "supnr",
              },
              {
                day: 2,
                isOnBussiness: true,
                openTime: "09:00:00",
                closeTime: "18:00:00",
                time: ["09:00:00", "18:00:00"],
                type: 2,
                appId: "supnr",
              },
              {
                day: 3,
                isOnBussiness: true,
                openTime: "09:00:00",
                closeTime: "18:00:00",
                time: ["09:00:00", "18:00:00"],
                type: 2,
                appId: "supnr",
              },
              {
                day: 4,
                isOnBussiness: true,
                openTime: "09:00:00",
                closeTime: "18:00:00",
                time: ["09:00:00", "18:00:00"],
                type: 2,
                appId: "supnr",
              },
              {
                day: 5,
                isOnBussiness: true,
                openTime: "09:00:00",
                closeTime: "18:00:00",
                time: ["09:00:00", "18:00:00"],
                type: 2,
                appId: "supnr",
              },
              {
                day: 6,
                isOnBussiness: true,
                openTime: "09:00:00",
                closeTime: "18:00:00",
                time: ["09:00:00", "18:00:00"],
                type: 2,
                appId: "supnr",
              },
              {
                day: 7,
                isOnBussiness: true,
                openTime: "09:00:00",
                closeTime: "18:00:00",
                time: ["09:00:00", "18:00:00"],
                type: 2,
                appId: "supnr",
              },
              {
                day: 0,
                isOnBussiness: true,
                openTime: "",
                closeTime: "",
                time: [],
                type: 2,
                appId: "supnr",
              },
            ],
          },
        ],
      },
      dialog: false,
    };
  },
  watch: {
    form: {
      handler() {
        let form= this.form
        for (let i = 0; i < form.mchShopBizTimes.length; i++) {
          for (let t = 0; t < form.mchShopBizTimes[i].week.length; t++) {
            if (
              form.mchShopBizTimes[i].week[t].time &&
              form.mchShopBizTimes[i].week[t].time.length > 1
            ) {
              form.mchShopBizTimes[i].week[
                t
              ].openTime = form.mchShopBizTimes[i].week[t].time[0];
              form.mchShopBizTimes[i].week[
                t
              ].closeTime = form.mchShopBizTimes[i].week[t].time[1];
            }
          }
        }
        this.$emit("change", form);
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    if (this.formData.id) {
      let data = [...this.formData.mchShopBizTimes];
      let mchShopBizTimes = [
        {
          title: "Business Hours - C.S.",
          prop: "mchShopBizTimes",
          week: [],
        },
        {
          title: "Business Hours - Delivery",
          prop: "mchShopBizTimes2",
          week: [],
        },
        {
          title: "Business Hours - Services",
          prop: "mchShopBizTimes3",
          week: [],
        },
      ];
      for (let i = 0; i < data.length; i++) {
        if (data[i].isOnBussiness == 1) {
          data[i].isOnBussiness = true;
        } else {
          data[i].isOnBussiness = false;
        }
        data[i].time = "";
        if (data[i].openTime) {
          data[i].time = [data[i].openTime, data[i].closeTime];
        }
        if (data[i].type == 0) {
          mchShopBizTimes[0].week.push(data[i]);
        }
        if (data[i].type == 1) {
          mchShopBizTimes[1].week.push(data[i]);
        }
        if (data[i].type == 2) {
          mchShopBizTimes[2].week.push(data[i]);
        }
      }
      if (data.length == 0) {
        mchShopBizTimes = [
          {
            title: "Business Hours - C.S.",
            week: [
              {
                day: 1,
                isOnBussiness: false,
                openTime: "",
                closeTime: "",
                time: "",
                type: 0,
                appId: "supnr",
              },
              {
                day: 2,
                isOnBussiness: false,
                open: "",
                closeTime: "",
                time: "",
                type: 0,
                appId: "supnr",
              },
              {
                day: 3,
                isOnBussiness: false,
                open: "",
                closeTime: "",
                time: "",
                type: 0,
                appId: "supnr",
              },
              {
                day: 4,
                isOnBussiness: false,
                open: "",
                closeTime: "",
                time: "",
                type: 0,
                appId: "supnr",
              },
              {
                day: 5,
                isOnBussiness: false,
                open: "",
                closeTime: "",
                time: "",
                type: 0,
                appId: "supnr",
              },
              {
                day: 6,
                isOnBussiness: false,
                open: "",
                closeTime: "",
                time: "",
                type: 0,
                appId: "supnr",
              },
              {
                day: 7,
                isOnBussiness: false,
                open: "",
                closeTime: "",
                time: "",
                type: 0,
                appId: "supnr",
              },
              {
                day: 0,
                isOnBussiness: false,
                open: "",
                time: "",
                closeTime: "",
                type: 0,
                appId: "supnr",
              },
            ],
          },
          {
            title: "Business Hours - Delivery",
            week: [
              {
                day: 1,
                isOnBussiness: false,
                open: "",
                closeTime: "",
                type: 1,
                appId: "supnr",
                time: "",
              },
              {
                day: 2,
                isOnBussiness: false,
                open: "",
                closeTime: "",
                type: 1,
                time: "",
                appId: "supnr",
              },
              {
                day: 3,
                isOnBussiness: false,
                open: "",
                closeTime: "",
                type: 1,
                time: "",
                appId: "supnr",
              },
              {
                day: 4,
                isOnBussiness: false,
                open: "",
                closeTime: "",
                type: 1,
                time: "",
                appId: "supnr",
              },
              {
                day: 5,
                isOnBussiness: false,
                open: "",
                closeTime: "",
                type: 1,
                time: "",
                appId: "supnr",
              },
              {
                day: 6,
                isOnBussiness: false,
                open: "",
                closeTime: "",
                type: 1,
                time: "",
                appId: "supnr",
              },
              {
                day: 7,
                isOnBussiness: false,
                open: "",
                closeTime: "",
                type: 1,
                time: "",
                appId: "supnr",
              },
              {
                day: 0,
                isOnBussiness: false,
                open: "",
                closeTime: "",
                type: 1,
                time: "",
                appId: "supnr",
              },
            ],
          },
          {
            title: "Business Hours - Services",
            week: [
              {
                day: 1,
                isOnBussiness: false,
                open: "",
                closeTime: "",
                type: 2,
                time: "",
                appId: "supnr",
              },
              {
                day: 2,
                isOnBussiness: false,
                open: "",
                closeTime: "",
                type: 2,
                time: "",
                appId: "supnr",
              },
              {
                day: 3,
                isOnBussiness: false,
                open: "",
                closeTime: "",
                type: 2,
                time: "",
                appId: "supnr",
              },
              {
                day: 4,
                isOnBussiness: false,
                open: "",
                closeTime: "",
                type: 2,
                time: "",
                appId: "supnr",
              },
              {
                day: 5,
                isOnBussiness: false,
                open: "",
                closeTime: "",
                type: 2,
                time: "",
                appId: "supnr",
              },
              {
                day: 7,
                isOnBussiness: false,
                open: "",
                closeTime: "",
                type: 2,
                time: "",
                appId: "supnr",
              },
              {
                day: 7,
                isOnBussiness: false,
                open: "",
                closeTime: "",
                type: 2,
                time: "",
                appId: "supnr",
              },
              {
                day: 0,
                isOnBussiness: false,
                open: "",
                closeTime: "",
                type: 2,
                time: "",
                appId: "supnr",
              },
            ],
          },
        ];
      }
      let shopTime = JSON.stringify(mchShopBizTimes);
      this.form.mchShopBizTimes = JSON.parse(shopTime);
    }
  },
};
</script>
<style scoped>
.input {
  display: flex;
  margin-bottom: 10px;
}
.week_name {
  width: 120px;
  display: flex;
}
.button {
  margin-left: 20px;
}
span {
  margin: 0 10px;
}
</style>